import { BaseResponseHttp } from './commons.model';
import { NumberCons, StringConst } from '../../constants/const';
import { BannerTypeConfig } from '../local/banner.model';

export class IOptionsHome extends BaseResponseHttp {
  response?: OptionsHome;
}
export class OptionsHome {
  images: ItemHome[];
  carousel: BannerTypeConfig[];
  socialNetworks: ItemHome[];
  constructor() {
    this.images = [];
    this.carousel = [];
    this.socialNetworks = [];
  }
}
export class ItemHome {
  id: number;
  key: string;
  name: string;
  imgUrl: string;
  route: string;
  isExternalUrl: boolean;
  productToSearch: string;
  group: string;
  constructor() {
    this.id = NumberCons.zero;
    this.key = StringConst.empty;
    this.name = StringConst.empty;
    this.imgUrl = StringConst.empty;
    this.route = StringConst.empty;
    this.isExternalUrl = false;
    this.productToSearch = StringConst.empty;
    this.group = StringConst.empty;
  }
}
export class SectionMenu {
  icon?: string;
  title?: string;
  description?: string;
}
